import {
  hotRouteConfig,
  HttpError,
  makeRouteConfig,
  Redirect,
  Route,
} from 'found';
import get from 'lodash/get';
import React from 'react';
import auth from 'lib/auth';
import VersionedRoute from 'ripple/Utils/VersionedRoute';
import ActivitiesPage from 'pages/Activities';
// import LoyaltyPage from 'pages/Loyalty';
import ZohoCustomerSupportPage from 'pages/ZohoCustomerSupport.js';
// import AnnouncementPage from 'pages/Announcement';
// import AnnouncementPreviewPage from 'pages/AnnouncementPreview';
import CodeOfConduct from 'components/CodeOfConduct';
import CodeOfConductPage from 'pages/CodeOfConduct';
import CommentPage from 'pages/Comment';
import CommunityDetailsPage from 'pages/Community/Details';
import CommunityEventsPage from 'pages/Community/Events';
import CommunityProductsPage from 'pages/Community/Products';
import CommunityWaiverPage from 'pages/Community/Waiver';
// import ContestPage from 'pages/Contest';
import DisclosureTutorial from 'components/DisclosureTutorial';
import DisclosureTutorialPage from 'pages/DisclosureTutorial';
import DiscoverCommunitiesPage from 'pages/Discover/Communities';
import DiscoverProductsPage from 'pages/Discover/Products';
// import EventDetailsPage from 'pages/Event/Details';
import EventDetails from 'ripple/Events/EventDetails';
// import EventFaqPage from 'pages/Event/Faq';
// import EventFavorsPage from 'pages/Event/Favors';
// import EventAgreementPage from 'pages/Event/Agreement';
// import EventProductsPage from 'pages/Event/Products';
import Events from 'ripple/Events';
import GatedContentPage from 'pages/GatedContent';
import HomePage from 'pages/Home';
import LinkPage from 'pages/Link';
import MediumPage from 'pages/Medium';
import OldLinkPage from 'pages/Link/old';
import NotificationsPage from 'pages/Notifications';
import PrivacyPolicy from 'components/PrivacyPolicy';
import PrivacyPolicyPage from 'pages/PrivacyPolicy';
import ProductPage from 'pages/Product';
import ProfileAboutMePage from 'pages/Profile/AboutMe';
import ProfileFeedPage from 'pages/Profile/Feed';
import ProfileParticipationPage from 'pages/Profile/Participation';
import ProfileSettingsPage from 'pages/Profile/Settings';
import ReviewPage from 'pages/Review';
import SignInPage from 'pages/SignIn';
// import SignInCallbackPage from 'pages/SignInCallback';
import SignOutPage from 'pages/SignOut';
import TermsOfService from 'components/TermsOfService';
import TermsOfServicePage from 'pages/TermsOfService';
import UnsubscribePage from 'pages/Unsubscribe';
import SocialSharePage from 'pages/SocialSharePage';
// import Login from 'ripple/SignIn/Login';
import EventView from '../pages/EventView';
// import LoyaltyStatusPage from '../pages/LoyaltyStatus/LoyaltyStatus';
import BarrelOfEvents from '../pages/BarrelOfEvents';
import TiktokChallenge from '../pages/TiktokChallenge';
import Dashboard from '../pages/Dashboard/Dashboard';
import NewEvent from '../pages/NewEventPage/NewEvent';
import GameOption from '../pages/GameOption';
import ClientAuth from '../components/Authenticator/ClientAuth';
import Perdue from '../pages/NewEventPage/Perdue';
import { isEmpty } from '../utils/validators';
import Survey from '../pages/Survey';
import Lucy from '../pages/Lucy';
import DownloadApp from '../pages/DownloadApp';

const existsPreRender = path => ({ done, extraData }) => {
  if (done && !get(extraData, path, false)) {
    throw new HttpError(404);
  }
};
const communityExistsPreRender = existsPreRender('viewer.community.id');
const eventExistsPreRender = existsPreRender('viewer.event.id');
const nodeExistsPreRender = existsPreRender('node.id');

class ProtectedRoute extends Route {
  getComponent = async () => {
    const isSignedIn = await auth.isRefreshIn();
    if (isEmpty(isSignedIn)) {
      throw new HttpError(401);
    }
    return this.Component;
  };
}

export default hotRouteConfig(
  makeRouteConfig(
    <Route path='/'>
      <Route Component={HomePage} />
      <Redirect from='login' to='/sign-in' />
      <Route path='/client/auth' Component={ClientAuth} />
      <ProtectedRoute forceFetch path='activities' Component={ActivitiesPage} />
      <ProtectedRoute forceFetch path='dashboard' Component={Dashboard} />
      {/* <ProtectedRoute forceFetch path='loyalty/rewards' Component={LoyaltyPage} /> */}
      {/* <ProtectedRoute forceFetch path='loyalty/status' Component={LoyaltyStatusPage} /> */}
      <ProtectedRoute
        forceFetch
        path='support'
        Component={ZohoCustomerSupportPage}
      />
      {/* <Route
        path='announcements/:id/:secret'
        Component={AnnouncementPreviewPage}
      />
      <Route
        forceFetch
        path='announcements/:nodeId'
        Component={AnnouncementPage}
        prerender={nodeExistsPreRender}
      /> */}
      <Redirect from='announcements' to='/discover' />
      <Route path='code-of-conduct' Component={CodeOfConductPage} />
      <Route
        forceFetch
        path='comments/:nodeId'
        Component={CommentPage}
        prerender={nodeExistsPreRender}
      />
      <Redirect from='comments' to='/' />
      <Route
        path='communities/:communitySlug/events'
        Component={CommunityEventsPage}
        prerender={communityExistsPreRender}
      />
      <Route
        path='communities/:communitySlug/products'
        Component={CommunityProductsPage}
        prerender={communityExistsPreRender}
      />
      <Route
        path='communities/:communitySlug/waiver'
        Component={CommunityWaiverPage}
        prerender={communityExistsPreRender}
      />
      <Route
        forceFetch
        path='communities/:communitySlug'
        Component={CommunityDetailsPage}
        prerender={communityExistsPreRender}
      />
      <Redirect from='communities' to='/discover/communities' />
      {/* <Route
        path='contests/:nodeId'
        Component={ContestPage}
        prerender={nodeExistsPreRender}
      />
      <Redirect from='contests' to='/' /> */}
      <Redirect from='conduct' to='/code-of-conduct' />
      <Route path='disclosure-tutorial' Component={DisclosureTutorialPage} />
      <Route path='discover/communities' Component={DiscoverCommunitiesPage} />
      <Route
        forceFetch
        path='discover/events'
        Component={Events}
      />
      <Route path='discover/products' Component={DiscoverProductsPage} />
      <Redirect from='discover' to='/discover/events' />
      <Route path='embed/code-of-conduct' Component={CodeOfConduct} />
      <Route path='embed/privacy-policy' Component={PrivacyPolicy} />
      <Route path='embed/terms-of-service' Component={TermsOfService} />
      <Route path='embed/disclosure-tutorial' Component={DisclosureTutorial} />
      <Redirect from='embed' to='/' />
      <Redirect from='events/:eventSlug/activities' to='/events/:eventSlug' />
      <Redirect from='events/:eventSlug/agreement' to='/events/:eventSlug' />
      <Redirect from='events/:eventSlug/faq' to='/events/:eventSlug\?feedtype=FAQ' />
      <Redirect from='events/:eventSlug/favors' to='/events/:eventSlug' />
      <Redirect from='events/:eventSlug/products' to='/events/:eventSlug' />
      {/* <Route
        path='events/:eventSlug/agreement'
        Component={EventAgreementPage}
        prerender={eventExistsPreRender}
      />
      <Route
        path='events/:eventSlug/faq'
        Component={EventFaqPage}
        prerender={eventExistsPreRender}
      />
      <Route
        path='events/:eventSlug/favors'
        Component={EventFavorsPage}
        prerender={eventExistsPreRender}
      />
      <Route
        path='events/:eventSlug/products'
        Component={EventProductsPage}
        prerender={eventExistsPreRender}
      /> */}
      <Route path='socialShare/:shareId' Component={SocialSharePage} />
      <VersionedRoute
        forceFetch
        path='events/:eventSlug'
        Component={{ new: EventDetails, soccer: NewEvent, perdue: Perdue }}
        prerender={eventExistsPreRender}
      />
      <ProtectedRoute
        forceFetch
        path='events/:eventSlug/tiktok-challenge'
        Component={TiktokChallenge}
        prerender={eventExistsPreRender}
      />
      <Redirect from='events' to='/discover/events' />
      <Route
        forceFetch
        path='links/:nodeId'
        Component={LinkPage}
        prerender={nodeExistsPreRender}
      />
      <Route
        forceFetch
        path='link/:linkSlug'
        Component={OldLinkPage}
        prerender={existsPreRender('viewer.link.id')}
      />
      <Route
        forceFetch
        path='media/:nodeId'
        Component={MediumPage}
        prerender={nodeExistsPreRender}
      />
      <Redirect from='media' to='/' />
      <ProtectedRoute path='notifications' Component={NotificationsPage} />
      <Redirect from='parties' to='/discover/events' />
      <Route path='privacy-policy' Component={PrivacyPolicyPage} />
      <Redirect from='privacy' to='/privacy-policy' />
      <Route
        forceFetch
        path='products/:productSlug'
        Component={ProductPage}
        prerender={existsPreRender('viewer.product.id')}
      />
      <Redirect from='products' to='/discover/products' />
      <ProtectedRoute path='profile' Component={ProfileAboutMePage} />
      <ProtectedRoute path='profile/feed' Component={ProfileFeedPage} />
      <ProtectedRoute
        path='profile/participation'
        Component={ProfileParticipationPage}
      />
      <ProtectedRoute
        path='profile/settings/:isUnsubscribe?'
        Component={ProfileSettingsPage}
      />
      <Route
        forceFetch
        path='reviews/:nodeId'
        Component={ReviewPage}
        prerender={nodeExistsPreRender}
      />
      <Redirect from='reviews' to='/' />
      <Redirect from='settings' to='/profile/settings' />
      {/* <Route path='sign-in/callback' Component={SignInCallbackPage} /> */}
      <Route name='sign-in' path='sign-in' Component={SignInPage} />
      <Route path='sign-out' Component={SignOutPage} />
      <Route path='gated/:destination(.*)?' Component={GatedContentPage} />
      <Route path='terms-of-service' Component={TermsOfServicePage} />
      <Redirect from='terms' to='/terms-of-service' />
      <Redirect from='tos' to='/terms-of-service' />
      <Route
        path='subscriptions/unsubscribe/:unsubscribeKey'
        Component={UnsubscribePage}
      />
      <Redirect from='unsubscribe' to='/settings' />
      <Route path='discover/alcohol' Component={BarrelOfEvents} />
      <Route
        path='events/:eventSlug/view'
        forceFetch
        prerender={eventExistsPreRender}
        Component={EventView}
      />
      <Redirect
        from='notifications/unsubscribe'
        to='/profile/settings/unsubscribe'
      />
      <Route
        forceFetch
        path='game/:gameId/option/:slug'
        Component={GameOption}
      />
      <Redirect from='soccer' to='/events/soccer' />
      <ProtectedRoute path='survey/:surveyId' Component={Survey} />
      <ProtectedRoute path='lucy/:slug' Component={Lucy} />
      <Route path='app/download' Component={DownloadApp} />
    </Route>,
  ),
);
